var DealsApplication, PaginatedDealsBuilder,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsApplication = require('../application');

module.exports = PaginatedDealsBuilder = (function() {
  function PaginatedDealsBuilder(arg) {
    this.omitSearch = (arg != null ? arg : {}).omitSearch;
    this.triggerFetchSuccess = bind(this.triggerFetchSuccess, this);
    this.triggerFetchError = bind(this.triggerFetchError, this);
    this.events = _.clone(Backbone.Events);
    this.search = new DealsApplication(this._searchOptions());
    this.search.on('error', this.triggerFetchError);
    this.search.on('success', this.triggerFetchSuccess);
  }

  PaginatedDealsBuilder.prototype._searchOptions = function() {
    if (Groupon.onNoDealsPage) {
      return {
        unfiltered: true
      };
    } else {
      return _.omitUndefined({
        omitSearch: this.omitSearch
      });
    }
  };

  PaginatedDealsBuilder.prototype.triggerFetchError = function() {
    this.events.trigger('fetchError');
    return this.events.stopListening();
  };

  PaginatedDealsBuilder.prototype.triggerFetchSuccess = function() {
    return $((function(_this) {
      return function() {
        _this.events.trigger('fetchSuccess', _this.search);
        return _this.events.stopListening();
      };
    })(this));
  };

  PaginatedDealsBuilder.prototype.on = function() {
    var ref;
    return (ref = this.events).on.apply(ref, arguments);
  };

  return PaginatedDealsBuilder;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2RlYWxzL2Zyb250ZW5kL2hlbHBlcnMvcGFnaW5hdGVkX2RlYWxzX2J1aWxkZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2RlYWxzL2Zyb250ZW5kL2hlbHBlcnMvcGFnaW5hdGVkX2RlYWxzX2J1aWxkZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsdUNBQUE7RUFBQTs7QUFBQSxnQkFBQSxHQUFtQixPQUFBLENBQVEsZ0JBQVI7O0FBRW5CLE1BQU0sQ0FBQyxPQUFQLEdBQXVCO0VBQ1IsK0JBQUMsR0FBRDtJQUFFLElBQUMsQ0FBQSw0QkFBRixNQUFnQixJQUFkOzs7SUFDZCxJQUFDLENBQUEsTUFBRCxHQUFVLENBQUMsQ0FBQyxLQUFGLENBQVEsUUFBUSxDQUFDLE1BQWpCO0lBRVYsSUFBQyxDQUFBLE1BQUQsR0FBVSxJQUFJLGdCQUFKLENBQXFCLElBQUMsQ0FBQSxjQUFELENBQUEsQ0FBckI7SUFFVixJQUFDLENBQUEsTUFBTSxDQUFDLEVBQVIsQ0FBVyxPQUFYLEVBQW9CLElBQUMsQ0FBQSxpQkFBckI7SUFDQSxJQUFDLENBQUEsTUFBTSxDQUFDLEVBQVIsQ0FBVyxTQUFYLEVBQXNCLElBQUMsQ0FBQSxtQkFBdkI7RUFOVzs7a0NBUWIsY0FBQSxHQUFnQixTQUFBO0lBQ2QsSUFBRyxPQUFPLENBQUMsYUFBWDthQUNFO1FBQUEsVUFBQSxFQUFZLElBQVo7UUFERjtLQUFBLE1BQUE7YUFHRSxDQUFDLENBQUMsYUFBRixDQUNFO1FBQUEsVUFBQSxFQUFZLElBQUMsQ0FBQSxVQUFiO09BREYsRUFIRjs7RUFEYzs7a0NBT2hCLGlCQUFBLEdBQW1CLFNBQUE7SUFDakIsSUFBQyxDQUFBLE1BQU0sQ0FBQyxPQUFSLENBQWdCLFlBQWhCO1dBQ0EsSUFBQyxDQUFBLE1BQU0sQ0FBQyxhQUFSLENBQUE7RUFGaUI7O2tDQUluQixtQkFBQSxHQUFxQixTQUFBO1dBQ25CLENBQUEsQ0FBRSxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUE7UUFDQSxLQUFDLENBQUEsTUFBTSxDQUFDLE9BQVIsQ0FBZ0IsY0FBaEIsRUFBZ0MsS0FBQyxDQUFBLE1BQWpDO2VBQ0EsS0FBQyxDQUFBLE1BQU0sQ0FBQyxhQUFSLENBQUE7TUFGQTtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBRjtFQURtQjs7a0NBS3JCLEVBQUEsR0FBSSxTQUFBO0FBQ0YsUUFBQTtXQUFBLE9BQUEsSUFBQyxDQUFBLE1BQUQsQ0FBTyxDQUFDLEVBQVIsWUFBVyxTQUFYO0VBREUifQ==
